import { useEffect, useState } from 'react'
import { User } from 'react-feather'

const AVATAR_PALETTE = [
  { bg: '#EAF2FF', text: '#1D4ED8' },
  { bg: '#E8F7EE', text: '#15803D' },
  { bg: '#FFF4E6', text: '#C2410C' },
  { bg: '#F3E8FF', text: '#7E22CE' },
  { bg: '#FCE7F3', text: '#BE185D' },
  { bg: '#E0F2FE', text: '#0E7490' },
  { bg: '#ECFCCB', text: '#4D7C0F' },
  { bg: '#FFE4E6', text: '#BE123C' },
]

const hashString = (value = '') => {
  let hash = 0

  for (let index = 0; index < value.length; index += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(index)
    hash |= 0
  }

  return Math.abs(hash)
}

const getInitials = (fullName = '') => {
  const normalizedName = fullName.trim()

  if (!normalizedName) {
    return ''
  }

  const words = normalizedName.split(/\s+/).filter(Boolean)

  if (words.length >= 2) {
    return `${words[0][0]}${words[1][0]}`.toUpperCase()
  }

  return normalizedName.slice(0, 2).toUpperCase()
}

const ProfilePic = ({
  imgSrc,
  name = '',
  avatarSeed,
  altText = 'Profile Picture',
  width = 20,
  height = 20,
  style = {},
  testId = 'pmb-profile-pic',
}) => {
  const [showIcon, setShowIcon] = useState(!imgSrc)

  useEffect(() => {
    setShowIcon(!imgSrc)
  }, [imgSrc])

  const size = Math.min(Number(width) || 40, Number(height) || 40)
  const resolvedName = name || (altText !== 'Profile Picture' ? altText : '')
  const initials = getInitials(resolvedName)
  const seed = String(avatarSeed ?? resolvedName ?? '')
  const avatarColor = AVATAR_PALETTE[hashString(seed) % AVATAR_PALETTE.length]
  const textSize = Math.max(Math.floor(size * 0.36), 10)
  const iconSize = Math.max(size - 18, 12)

  if (!imgSrc || showIcon) {
    return (
      <div
        className="rounded-circle"
        aria-label={altText}
        data-testid={testId}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: initials ? avatarColor.bg : '#f3f4f6',
          color: initials ? avatarColor.text : '#9ca3af',
          width: `${width}px`,
          height: `${height}px`,
          aspectRatio: 1,
          fontSize: `${textSize}px`,
          fontWeight: 700,
          lineHeight: 1,
          userSelect: 'none',
          ...style,
        }}
      >
        {initials ? initials : <User size={iconSize} color="#9ca3af" />}
      </div>
    )
  }

  return (
    <img
      src={imgSrc}
      onError={() => {
        setShowIcon(true)
      }}
      className="rounded-circle"
      alt={altText}
      data-testid={testId}
      width={width}
      height={height}
      style={{
        objectFit: 'cover',
        width: `${width}px`,
        height: `${height}px`,
        aspectRatio: 1,
        ...style,
      }}
    />
  )
}

export default ProfilePic
